/* eslint-disable import/no-anonymous-default-export */
import { notification } from "antd";
import { useEffect, useState } from "react";
import useCodigosInfraccionAPI from "./useCodigosInfraccionAPI";

export default () => {
    const api = useCodigosInfraccionAPI();
    const [etiquetas, setEtiquetas] = useState<{ value: string, text: string }[]>([]);

    const loadEtiquetas = async () => {
        const response = await api.listEtiquetas()

        if (response.error) {
            notification.error({
                message: "Error al listar etiquetas"
            })
            return;
        }

        setEtiquetas(response.data!.value.map((c : any) => ({ text: c.nombre, value: c.nombre })));
    };

    useEffect(()=>{
        loadEtiquetas();
    },[]);

    return {etiquetas};
}